import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useProductFlags } from "src/hooks/recoil/useProductFlags";
import { useRouter } from "src/hooks/useRouter";
import { getProductFromSessionStorage } from "src/utils/storage/auth";

interface ISiteTypeOptionsProps {
  productKey: string; // 제품 키
  isRenew?: boolean;
}
// 요금제 선택. priceType은 URL 쿼리에서 파생하고 변경 시 직접 라우팅한다
// (폼 컨텍스트 비의존 — SitePay/Trial 어디서든 단독 사용 가능).
const SiteTypeOptions = ({
  productKey,
  isRenew = false,
}: ISiteTypeOptionsProps) => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const route = useRouter();
  const { isOciProduct } = useProductFlags();
  const priceType = searchParams.get("type") ?? "premium";
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    if (value === "trial") {
      route.goSiteTrial();
    } else if (value === "promotion") {
      route.goSitePromotion({});
    } else if (value !== priceType) {
      // 기본 결제 주기 연간으로 선택
      route.goPay({ pay: "year", type: value });
    }
  };
  return (
    <>
      <h4 className="form-title">
        {t("siteType." + priceType + ".orderSpecification.title")}
      </h4>
      <div className="form-item">
        <span className="form-item-title">
          {t("siteType." + priceType + ".orderSpecification.planType")}
        </span>
        {isOciProduct &&
        !searchParams.has("pay") &&
        !searchParams.has("type") ? (
          <span style={{ fontSize: "1rem" }}>
            {t(
              "siteType.subscriptionType." +
                productKey +
                ".subscriptionType_premium"
            )}
          </span>
        ) : (
          <Form.Select
            name="priceType"
            value={
              route.currentPath.includes("trial")
                ? "trial"
                : priceType === "premium"
                ? "promotion"
                : priceType
            }
            onChange={handleChange}
            className="form-control custom-form width w-370"
            disabled={isRenew || !isOciProduct}
          >
            {/* 
            에코 + 영문일때만 무료체험 옵션 보이게 한적있음
            {getProductFromSessionStorage() === "WRAPSODY_ECO" &&
            lang === "en" && (
              <option
                value="trial"
                // disabled={!confirmTrial}
              >
                {t(
                  "siteType.subscriptionType." +
                    productKey +
                    ".subscriptionType_free"
                )}
              </option>
            )} */}
            {getProductFromSessionStorage() === "WRAPSODY" && (
              <option
                value="drive"
                // disabled={!confirmDrive}
              >
                {t(
                  "siteType.subscriptionType." +
                    productKey +
                    ".subscriptionType_drive"
                )}
              </option>
            )}
            <option
              value="basic"
              // disabled={!confirmBasic}
            >
              {t(
                "siteType.subscriptionType." +
                  productKey +
                  ".subscriptionType_basic"
              )}
            </option>
            {/* {productKey === "wrapsody" && (
                      <option value="basicPlus" disabled={!confirmBasicPlus}>
                        {t(
                          "siteType.subscriptionType." +
                            productKey +
                            ".subscriptionType_basicPlus"
                        )}
                      </option>
                    )} */}
            <option
              value="plus"
              // disabled={!confirmPlus}
            >
              {t(
                "siteType.subscriptionType." +
                  productKey +
                  ".subscriptionType_plus"
              )}
            </option>

            {/* {productKey === "wrapsody" && (
                      <option value="plusPlus" disabled={!confirmPlusPlus}>
                        {t(
                          "siteType.subscriptionType." +
                            productKey +
                            ".subscriptionType_plusPlus"
                        )}
                      </option>
                    )} */}
            {!isOciProduct && (
              <option value="promotion">
                {t(
                  "siteType.subscriptionType." +
                    productKey +
                    ".subscriptionType_premium"
                )}
              </option>
            )}
          </Form.Select>
        )}
      </div>
    </>
  );
};
export default SiteTypeOptions;
